/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class dmerc extends IceEntity {
  dmerc_key: string = "";
  report_type_code: string = "";
  report_transmission_code: string = "";
  certification_type_code: string = "";
  unit_code: string = "";
  quantity: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "DMERC";
  }
}
